import { render } from "./PaymentPage.vue?vue&type=template&id=3742a782&scoped=true"
import script from "./PaymentPage.vue?vue&type=script&lang=js"
export * from "./PaymentPage.vue?vue&type=script&lang=js"

import "./PaymentPage.vue?vue&type=style&index=0&id=3742a782&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3742a782"]])

export default __exports__